module.exports = __webpack_public_path__ + "static/img/3d打印透明材料.0be0c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3d打印透明材料.png
// module id = CjgC
// module chunks = 2